import { Alert, alertTypes } from "@visiblethread/react-components";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideGlobalAlert } from "slices/app/appSlice";
import { selectGlobalAlert } from "slices/app/selectors";

const GlobalAlertHolder = () => {
  const dispatch = useDispatch();
  const alert = useSelector(selectGlobalAlert);

  const closeGlobalAlert = () => {
    dispatch(hideGlobalAlert());
  };

  if (!alert) {
    return null;
  }

  return (
    <Alert
      type={alertTypes.global}
      variant={alert.variant}
      text={alert.text}
      autoDismissible={!alert?.persistent}
      dismissTimeout={alert?.dismissTimeout || 5000}
      onClose={closeGlobalAlert}
    />
  );
};

export default GlobalAlertHolder;
